import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'enumTranslate',
  standalone: true,
})
export class EnumTranslatePipe implements PipeTransform {
  private readonly transloco = inject(TranslocoService);

  /**
   * Translates enum values to localized strings
   * @param value - The enum value to translate
   * @param enumType - The enum type name for the translation key (e.g., 'appointmentType', 'userCategory')
   * @returns Translated string or empty string if value is null/undefined
   * 
   * @example
   * {{ AppointmentWebTypeEnum.Reservation | enumTranslate:'appointmentType' }}
   * {{ UserCategoryEnum.Student | enumTranslate:'userCategory' }}
   */
  public transform(value: number | string | null | undefined, enumType: string): string {
    if (!value || !enumType) {
      return '';
    }

    const asString = String(value);
    // Convert first character to lowercase for proper translation key format
    // e.g., "Reservation" -> "reservation"
    const camelCaseValue = asString.charAt(0).toLowerCase() + asString.slice(1);
    const key = `enums.${enumType}.${camelCaseValue}`;
    
    return this.transloco.translate(key);
  }
}